/**
 * created by MarcusZhao on 2/6/20.
 * Description:
 *
 * ------ maintenance history ------
 */
export class ContactTemplateControlValue {
    value: any; // value, must be string or number
    displayValue: any; // value that will be displayed, used for adhoc
    ctrl: any;
    isFromUser: boolean;
    isFirstInit: boolean;
    constructor(value: any = '', displayValue: any = '', ctrl: any = {}, isFromUser = false, isFirstInit = false) {
        this.value = value;
        this.displayValue = displayValue;
        this.ctrl = ctrl;
        this.isFromUser = isFromUser;
        this.isFirstInit = isFirstInit;
    }
}
